module.exports = __webpack_public_path__ + "img/eScience_Logo_RGB.8ee78abe.svg";